import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../App';
import BackDropUI from '../MaterialUI/BackDropUI';
import ProjectCard from '../ProjectCard/ProjectCard';

const Manage_Projects = () => {
    const [cardDisplay, setCardDisplay, authentication, setAuthentication, snackBarUI, setSnackBarUI, backdropUI, setBackdropUI] = useContext(UserContext);

    const [data, setData] = useState([]);
    setBackdropUI(true);
    useEffect(() => {
        fetch('https://stormy-mesa-29040.herokuapp.com/getAllProjects')
            .then(res => res.json())
            .then(data => {
                setData(data)
            })
            .catch(err => {
                alert(err);
            })
    }, [])

    return (
        <div className="center-admin">
            <h1 className="m-3">Manage Projects</h1>
            {
                data.length !== 0 && setBackdropUI(false)
            }
            <section>
                {
                    data.map(projects => <ProjectCard data={projects}/>)
                }
            </section>
            <BackDropUI />
        </div>
    );
};

export default Manage_Projects;